import React from 'react';
import { MapPin } from 'lucide-react';
import { mockData } from '../mock';

export const Zone = () => {
  return (
    <section id="zone" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16 space-y-6">
          <div className="inline-flex items-center gap-2 text-emerald-700 mb-4">
            <div className="w-12 h-[2px] bg-emerald-700" />
            <span className="text-sm uppercase tracking-widest font-medium">Zones d'Intervention</span>
            <div className="w-12 h-[2px] bg-emerald-700" />
          </div>
          
          <h2 className="text-5xl md:text-6xl font-bold text-stone-900">
            {mockData.zone.title}
          </h2>
          
          <p className="text-2xl text-emerald-700 font-medium italic max-w-2xl mx-auto">
            {mockData.zone.description}
          </p>
        </div>

        {/* Map Section */}
        <div className="max-w-5xl mx-auto">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-emerald-100">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d373699.4573576896!2d4.621094193937877!3d43.451953651473416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12c9bf4344da5333%3A0x40819a5fd970220!2sBouches-du-Rh%C3%B4ne!5e0!3m2!1sfr!2sfr!4v1704196800000!5m2!1sfr!2sfr"
              width="100%" 
              height="600" 
              style={{ border: 0 }}
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Zone d'intervention - Bouches-du-Rhône"
            />
          </div>

          {/* Cities list below map */}
          <div className="mt-12 bg-gradient-to-br from-emerald-50 to-stone-50 rounded-2xl p-8 border border-emerald-200">
            <div className="flex items-center gap-3 mb-6">
              <MapPin className="w-6 h-6 text-emerald-700" />
              <h3 className="text-2xl font-bold text-stone-900">Principales villes desservies</h3>
            </div>
            
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {mockData.zone.areas.map((area, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 text-stone-700 font-medium"
                >
                  <div className="w-3 h-3 rounded-full bg-emerald-600 flex-shrink-0" />
                  <span>{area}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Footer note */}
          <div className="mt-12 text-center">
            <div className="inline-block px-8 py-4 bg-white rounded-2xl border-2 border-emerald-200 shadow-sm">
              <p className="text-stone-600 font-medium">
                Autres communes sur demande • Contactez-moi pour plus d'informations
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};